import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, { useState, useEffect } from "react";
import './style.css';

export default function MainCarousel2(carouselImgs) {
    const [data, setData] = useState([]);
    useEffect(() => {
        setData(carouselImgs.carouselImgs);
    }, [carouselImgs.carouselImgs]);

    return (
        <div>
            <div className="xl:max-w-7xl xl:mx-auto xl:px-8">
            <Carousel 
                autoPlay={true} 
                interval={3000}
                infiniteLoop={true}
                showArrows={true}
                showIndicators={true}
                showThumbs={false}
                dynamicHeight={true}
                showStatus={false}
                emulateTouch={true}
                >
                {
                    data.map((imageObject, index) => (
                        <div key={index}>
                            <img src={imageObject} alt="Slide Image"/>
                        </div>
                    ))
                }
            </Carousel>
        </div>
        </div>
    );
}